global.jQuery = global.$ = window.jQuery = require('jquery');
var jsSHA = require("jsSHA");
require('cookie');
require('velocity');
import 'core-js/features/number/is-nan'
import 'custom-event-polyfill'
import {
	Navigation,
	Autoplay,
	Pagination,
	EffectFade,
	Swiper,
	Thumbs
} from 'swiper'
Swiper.use([Pagination, Autoplay, Navigation, EffectFade, Thumbs])
import {
	gsap
} from "gsap";
import {
	ScrollTrigger
} from "gsap/ScrollTrigger";
import {
	ScrollToPlugin
} from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

$(function () {

	// Burger Menu Viewport
	const setFillHeight = () => {
		const vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}

	window.addEventListener('resize', setFillHeight);

	setFillHeight();
	
	// gallery Carousel
	const slideLength = document.querySelectorAll('.swiper-wrapper .swiper-slide').length;
  const slidable = slideLength > 1;
//	if (slideLength > 1) {
		var swiper = new Swiper('.p-limited-gallery__section', {
					slidesPerView: 1.5,
					centeredSlides: true,
					spaceBetween: 20,
					loop: slidable,
					speed: 800,
					effect: 'slide',
					navigation: {
						nextEl: '.p-limited-gallery__next',
						prevEl: '.p-limited-gallery__prev',
					},
					pagination: {
						el: '.swiper-pagination',
						type: 'bullets',
						clickable: true
					},
					breakpoints: {
						400: {
							slidesPerView: 1,
							spaceBetween: 10
						}
					},
					watchOverflow: true
		});
//}
	
	
	// Global Navigation

	const burger = $('.c-burger');
	const gnav = $('.l-navGlobal');
	const header = $('.l-header');
	let burgerFlag = false;

	burger.each(function () {
		burger.on('click', function () {
			if (!burgerFlag) {
				burger.addClass('isOpen');
				gnav.addClass('isActive');
				burgerFlag = true;
				header.addClass('isActive');
			} else {
				burger.removeClass('isOpen');
				gnav.removeClass('isActive');
				header.removeClass('isActive');

				burgerFlag = false;
			}
		});
	});



	checkHeaderClass();

	function checkHeaderClass() {
		if (burger.hasClass('isOpen')) {
			burger.removeClass('isOpen');
		}
		if (gnav.hasClass('isActive')) {
			gnav.removeClass('isActive');
		}
		if (header.hasClass('isActive')) {
			header.removeClass('isActive');
		}
		burgerFlag = false;
	}

	// Opacity Animation
	const jsFade = document.querySelectorAll('.jsFade');
	jsFade.forEach((element) => {
		gsap.from(element, {
			autoAlpha: 0,
			duration: .5,
			scrollTrigger: {
				trigger: element,
				start: "top 80%"
			},
			ease: "power4.in"
		});
	});


	// iframe height
	$('.js-iframe').on('load', function () {
		try {
			$(this).height(this.contentWindow.document.documentElement.scrollHeight);
		} catch (e) {}
	}).trigger('load');
	
	/*---------------------------------------------
		Login Pass
		---------------------------------------------*/
		//var lurl_tokaichi = '../limited/';
		//var lurl_tsunashima = '../limited-shintsunashima/';
		//var lurl_edakita = '../limited-edakita/';
		//var lurl_NTnakagawa = '../limited-NTnakagawa/';
		//var lurl_minamimachida = '../limited-minamimachida/';
		var lurl_musashikosugi = '../limited-musashikosugi/';
		var lurl_azamino = '../limited-azamino/';
		var lurl_saginuma = '../limited-saginuma/';
		var lurl_shinyokohama = '../limited-shinyokohama/';
	
		$('#loginBtn').on('click', function () {
			var shaObj = new jsSHA('SHA-256', 'TEXT');
			var loginPass = $('input[name=loginPass]').val();
			shaObj.update(loginPass);
			var passHash = shaObj.getHash('HEX');
			
			//if( passHash == '6f1e268aa721890d36b257104cc59f448fa8e41a8d4cf4e1ce7239937b32477b'){
			//	
			//	$.cookie('login', 'true' , {path: '/' });
			//	var loginUser = $.cookie('login');
			//	console.log(loginUser);
			//	location.href = lurl_tokaichi;
			//	
			//}
			//if( passHash == 'f7c08cbf489b79dd62a9aea931d773dcf79833747a511b56600c88358c595304'){
			//	
			//	$.cookie('login', 'true' , {path: '/' });
			//	var loginUser = $.cookie('login');
			//	console.log(loginUser);
			//	location.href = lurl_tsunashima;
				
			// } else if( passHash == '88dbe0d2e7acc02e3bec513e882b94ad4ef73c61c5535003639aa0fec84d9555'){
			// 	
			// 	$.cookie('login', 'true' , {path: '/' });
			// 	var loginUser = $.cookie('login');
			// 	console.log(loginUser);
			// 	location.href = lurl_edakita;
				
			//} else if( passHash == '1ac5e93af2014a9276ab5dd851d33c52408e7f2f0e755ca389992eaf20c3193b'){
			//	
			//	$.cookie('login', 'true' , {path: '/' });
			//	var loginUser = $.cookie('login');
			//	console.log(loginUser);
			//	location.href = lurl_NTnakagawa;
				
			//} else if( passHash == '94127b75f47708a773d04c03744f6d75981a48c5b151e631ba82c7cbba3e4143'){
			//	
			//	$.cookie('login', 'true' , {path: '/' });
			//	var loginUser = $.cookie('login');
			//	console.log(loginUser);
			//	location.href = lurl_minamimachida;

			if( passHash == '944854c2ee3e6c6670e2e4ac511e1b7a399e6dbf5735e9b6203c70861d5f71a9'){
				
				$.cookie('login', 'true' , {path: '/' });
				var loginUser = $.cookie('login');
				console.log(loginUser);
				location.href = lurl_musashikosugi;

			} else if( passHash == 'e9ab39f01d431c5250493a3dc493bba9c43f73a4461c72b5135ee09738582af7'){
				
				$.cookie('login', 'true' , {path: '/' });
				var loginUser = $.cookie('login');
				console.log(loginUser);
				location.href = lurl_azamino;

			} else if( passHash == '3e34b5dc434bcf3186f089d362691cfac1b17231601f2f402dc79015be878d83'){
				
				$.cookie('login', 'true' , {path: '/' });
				var loginUser = $.cookie('login');
				console.log(loginUser);
				location.href = lurl_saginuma;

			} else if( passHash == 'addfd9e96986dc1b9f818c36d7b9b56eed3928337c812515fa61ddd270335fba'){
				
				$.cookie('login', 'true' , {path: '/' });
				var loginUser = $.cookie('login');
				console.log(loginUser);
				location.href = lurl_shinyokohama;
				
				
			} else{
				alert('パスワードが違います');
			}
		});
		
		if($('.l-main').hasClass('limited')){
			var loginUser = $.cookie('login');
			console.log(loginUser);
			if(loginUser != 'true'){
				location.href = '../login/';
			} else if (document.URL.match('/limited-edakita/')) {
				location.href = '../login/';
			} else if (document.URL.match('/limited/')) {
				location.href = '../login/';
			} else if (document.URL.match('/limited-NTnakagawa/')) {
				location.href = '../login/';
			} else if (document.URL.match('/limited-minamimachida/')) {
				location.href = '../login/';
			} else if (document.URL.match('/limited-shintsunashima/')) {
				location.href = '../login/';
			}
		}




	//popup window
	$.fn.openwin = function (settings) {
		settings = $.extend({
			option: {
				width: false,
				height: false,
				top: false,
				left: false,
				menubar: 'no',
				toolbar: 'no',
				location: 'no',
				status: 'no',
				resizable: 'no',
				scrollbars: 'no',
				directories: 'no',
				titlebar: 'yes',
				fullscreen: 'no'
			},
			target: '_blank',
			blur: false,
			focus: false
		}, settings);

		$(this).on('click', function () {
			var options = [];
			var target = settings.target;
			var url = $(this).attr('href');

			if ($(this).attr('rel')) {
				var rel = $(this).attr('rel').split(',');
				var relOption = {};
				$.each(settings.option, function (i, rel) {
					var a = rel[i].split('=');
					relOption[a[0]] = a[1];
				});
			}

			$.each(settings.option, function (k) {
				var v = settings.option[k];
				if (relOption) {
					if (relOption[k]) {
						v = relOption[k];
					}
				}
				if (v) {
					options.push(k + '=' + v);
				}
			});
			if (relOption) {
				if (relOption['target']) {
					target = relOption['target'];
				}
			}
			var newWin = window.open(url, target, options.join(','));
			if (settings.blur === true) {
				newWin.blur();
			}
			if (settings.focus === true) {
				newWin.focus();
			}
			return false;
		});
		return this;
	};

	$('a.js-popup').openwin({
		option: {
			width: 1000,
			height: 900,
			top: false,
			left: false,
			menubar: "no",
			toolbar: "no",
			location: "no",
			status: "no",
			resizable: "yes",
			scrollbars: "yes",
			directories: "no",
			titlebar: "yes",
			fullscreen: "no"
		}
	});
});


//ナビ左揃え用
var $grid = $('.p-limited-gallery__tab'),
		naviNumber = ~~(document.documentElement.clientWidth / 230),
    naviList = $(".p-limited-gallery__element").length,
    naviRemainder = naviNumber - (naviList % naviNumber),
    emptyCells = [],
    i;

if( naviList > naviNumber && document.documentElement.clientWidth >= 992 ){
	for (i = 0; i < naviRemainder; i++) {
    emptyCells.push($('<li>', { class: 'p-limited-gallery__element is-empty' }));
	}
}

$grid.append(emptyCells);



	/*---------------------------------------------
		タブ・プルダウンの切り替え
		---------------------------------------------*/
function convertAllATagsToSelect() {
  const aTags = document.querySelectorAll('a.p-limited-gallery__element');
	//const iFrame = document.querySelector('.p-limited-gallery__flame.js-iframe');
  if (aTags.length === 0) return;  // <a>タグが存在しなければ何もしない

  const select = document.createElement('select');
	select.onchange = function() {
    location.href = this.value;
  };

  aTags.forEach(aTag => {
    const option = document.createElement('option');
    option.value = aTag.href;
    option.textContent = aTag.textContent;
    option.className = aTag.className;
		select.appendChild(option);
    //select.insertBefore(option, select.firstChild); // 逆順で追加
		if (option.classList.contains("current")) { // クラスリストを使用して "Current" クラスを確認
			select.value = option.value;
		}

    aTag.remove();  // 元の<a>タグを削除
  });
	/* // <option>要素を全て追加した後で、選択状態を設定
	const currentOption = [...select.options].find(option => option.classList.contains('current'));
	if (currentOption) {
		select.value = currentOption.value;
	} */
	const pTag = document.createElement('p');
	pTag.textContent = "下記のボタンをクリックして、過去にアップした記事もご覧いただけます。";
	pTag.className = "c-text c-text_caption u-text-center";

  const target = document.querySelector('.p-limited-gallery__tab');
  target.appendChild(pTag);
  // <select>タグをDOMに追加する。この例では<body>タグの最後に追加
  target.appendChild(select);
}

function convertAllSelectToATags() {
  const options = document.querySelectorAll('option.p-limited-gallery__element');
  if (options.length === 0) return;

  const select = document.querySelector('.p-limited-gallery__tab select');
  const pTag = document.querySelector('.p-limited-gallery__tab > p');
  const target = document.querySelector('.p-limited-gallery__tab');

  options.forEach(option => {
    const aTag = document.createElement('a');
    aTag.href = option.value;
		aTag.textContent = option.textContent;
    aTag.className = option.className;
		target.appendChild(aTag);
		//target.insertBefore(aTag, target.firstChild);
    option.remove();
  });

	select.remove();
	pTag.remove();
}

function responsiveConversion() {
  const screenWidth = window.innerWidth;

  if (screenWidth <= 768) {
    convertAllATagsToSelect();
  } else {
    convertAllSelectToATags();
  }
}

window.addEventListener('resize', responsiveConversion);
// 初期ロード時にも実行
responsiveConversion();

